import PropTypes from "prop-types";
import { Marker } from "react-leaflet";

/**
 * Non-interactive Leaflet Marker used as a map legend.
 *
 * @param props - The Leaflet Marker component props.
 * @returns The rendered legend marker.
 */
const Legend = (props) => {
    return <Marker {...props} interactive={false} />;
};

Legend.propTypes = {
    draggable: PropTypes.bool,
    icon: PropTypes.any,
    opacity: PropTypes.number,
    position: PropTypes.any,
};

export default Legend;
